export default "__VITE_ASSET__CpDCEdzj__"